(ns quuppa.ui.tooltip
  (:require [reagent.core :as r]
            ["react-bootstrap/Overlay$default" :as Overlay]
            ["react-bootstrap/OverlayTrigger$default" :as OverlayTrigger]
            ["react-bootstrap/Tooltip$default" :as Tooltip]))

(def overlay (r/adapt-react-class Overlay))
(def overlay-trigger (r/adapt-react-class OverlayTrigger))
(def tooltip (r/adapt-react-class Tooltip))
